<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyname"></comHeaderAuth>
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- 申込キー情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="9" lg="9" xl="9">
            <v-banner single-line>
              <v-avatar slot="icon" color="primary" size="40">
                <v-icon icon="map-marker-alert-outline" color="white">mdi-map-marker-alert-outline</v-icon>
              </v-avatar>
              <template v-if="this.cancelMessage">
                <v-row>
                  <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="ma-0">
                    <span small class="red--text">このお申込みはキャンセルされています。</span>
                  </v-col>
              </v-row>
              </template>
              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="mt-3">
                  <p>申込番号：{{ dispRequestNo }}</p>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="mt-3">
                  <p>申込日：{{ dispRequesuDate }}</p>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="d-flex align-center justify-end mt-3">
                  <v-btn small color="red" class="white--text" min-width="150px" :disabled="cancelInactive" @click="cancel()">お申込みキャンセル</v-btn>
                  <!-- <v-btn small min-width="150px" color="red" disabled="true" @click="cancel()">お申込みキャンセル</v-btn> -->
                </v-col>
              </v-row>
            </v-banner>
          </v-col>
        </v-row>
        <!-- プラン情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoPlanInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  expand-icon="mdi-menu-down"
                  class="panel-title"
                >
                  <label>申込プラン</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <span v-html="dispPlanNm"></span>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        
        <!-- 役員情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoOfficerInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">役員情報</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="pl-2 pt-6">
                    <v-col cols="12">
                      <span v-html="dispChangeOfficerDate"></span>
                    </v-col>
                  </v-row>
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  :single-expand="dispOfficerSingleExpand"
                  :expanded.sync="expanded"
                  :key="isMobile ? expanded.length : ''"
                  item-key="changeNo"
                  show-expand 
                  disable-pagination
                  hide-default-footer
                  :disable-sort="true"
                  calculate-widths
                  class="v-data-table elevation-3 v-dtbl-md-1 mt-5"
                >
                  <!-- <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="expand-box">
                        <span class="box-title">役員変更詳細</span>
                        <p v-html="item.regmatter"></p>
                      </div>       
                    </td>
                  </template> -->
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="expand-box">
                        <span class="box-title">役員住所</span>
                        <p v-html="item.address"></p>
                      </div>       
                    </td>
                  </template>
                </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <!-- 登記情報ファイル情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="12" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoFileInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">登記情報ファイル</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <v-row>
                    <v-col cols="6" class="d-flex align-center justify-start ">

                      <template v-if="dispFileDownloadLink">
                        <a :href="dispPdfFileBlobUrl" download="touki.pdf">ファイルが見れない場合</a>
                      </template>
                    </v-col>
                    <v-col cols="6" class="d-flex align-center justify-end pa-0">
                      <!-- <template v-if="fileUploadFlg">
                        <v-file-input @change="uploadFileInfo($event)" @click="clearFileInfo($event)" outlined dense  accept=".pdf" class="file-input d-flex align-center justify-end mr-6" ref="vFileInput" prepend-icon="" height="4" hide-input>
                          <template v-slot:append-outer>
                            <div @click="handleClickAppendOuter()">
                              <v-btn elevation="4" color="warning" class="sentaku-btn2 white--text">アップロード</v-btn>
                            </div>
                          </template>
                        </v-file-input>
                      </template> -->
                    </v-col>
                    <!-- <v-col cols="4" sm="4" md="4" lg="4" xl="3" class="d-flex align-start justify-end mb-1 pr-0">
                      <v-btn color="warning" dark min-width="80px" @click="deleteFileInfo(requestNo, fileId)">削除</v-btn>
                    </v-col> -->
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <iframe id="iframeFile" :src="dispPdfFileBlobUrl" width="100%"></iframe>
                      <!-- <input type="file" accept="image/*" @change="onFileChange($event)"> -->
                    </v-col>
                  </v-row>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        
        <!-- 登記変更詳細情報 -->
        <!-- <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoDatailInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">登記変更詳細情報</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <span v-html="dispRegChgInfo"></span>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12">
            <v-sheet min-height="1vh" color="transparent"></v-sheet>
          </v-col>
        </v-row>
        <!-- ボタン -->
        <v-row justify="center" align-content="start">
          <v-col cols="12" class="d-flex align-center justify-center">
              <v-btn x-large color="warning" dark min-width="200px" @click="back()">戻る</v-btn>
          </v-col>
        </v-row>

        <!-- その他 -->
        <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
        <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
        <comMessageConfirm :msg="dlgMsgConfirm.msg" :isOpen="dlgMsgConfirm.isOpen" :doYes="dlgMsgConfirm.doYes" :doNo="dlgMsgConfirm.doNo" />
        <comMessageConfirm :msg="dlgMsgConfirmDel.msg" :isOpen="dlgMsgConfirmDel.isOpen" :doYes="dlgMsgConfirmDel.doYes" :doNo="dlgMsgConfirmDel.doNo" />
        <comMessageConfirm :msg="dlgMsgConfirmCancel.msg" :isOpen="dlgMsgConfirmCancel.isOpen" :doYes="dlgMsgConfirmCancel.doYes" :doNo="dlgMsgConfirmCancel.doNo" />
        <v-fab-transition>
          <v-btn
            color="indigo"
            fab
            dark
            large
            absolute
            right
            style="bottom:20px; position:fixed;"
            @click="$vuetify.goTo(0)"  
            v-show="buttonActive"
          >
            <v-icon>mdi-navigation</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from "../common/utils";


export default {
  name: "InputRequestConfirm",
  data() {
    return {
      username: "",
      companyname: "",
      screenTitle: "お申込確認",
      screenId: "MBR500",
      messageArea: "",
      moveTopButton: 'right',

      cancelInactive: false,
      cancelMessage: false,

      customerId: "",
      requestNo: "",
      dispFileDownloadLink: false,
      fileId:"",
      fileUploadFlg: false,
      planMstrList: null,
      reasonMstrList: null,
      selectedPlanIdList: null,
      dispRequestNo: "",
      dispRequesuDate: "",
      dispPlanNm: "",
      dispPdfFileBlobUrl: null,
      dispOfficerSingleExpand: true,
      dispRegChgInfo: "",
      returnViewUrl: "",

      dispChangeOfficerDate: "",
 
      updateDatetime:"",
      updateUserId:"",

      panelNoPlanInfo: 0,
      panelNoFileInfo: 0,
      panelNoOfficerInfo: 0,
      panelNoDatailInfo: 0,

      buttonActive: false,
      scroll: 0,

      isMobile: false,
      expanded: [],

      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
        },
      },      
      dlgMsgConfirm: {
        msg: Constants.MSG_INF_REQUEST_REGIST_COMPD,
        isOpen: false,
        doYes: () => {
          // ストア初期化
          this.$store.commit("requestRegInfo/resetState");
          this.$router.push("/AfterRequest");
          this.dlgMsgConfirm.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgConfirm.isOpen = false;
        },
      },
      dlgMsgConfirmDel: {
        msg: this.$i18n.t('msg.wrn.cm012', ['登記情報ファイル']),
        requestNo: "",
        fileId:"",
        isOpen: false,
        doYes: () => {
          this.request(this.dlgMsgConfirmDel.requestNo, this.dlgMsgConfirmDel.fileId);
          this.dlgMsgConfirmDel.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgConfirmDel.isOpen = false;
        },
      },
      dlgMsgConfirmCancel: {
        msg: this.$i18n.t('msg.wrn.mb030'),
        isOpen: false,
        doYes: () => {
          this.requestCancel();
          this.dlgMsgConfirmCancel.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgConfirmCancel.isOpen = false;
        },
      },      
      headers: [
        { text: "No", align: "start", value: "changeNo", width: "7%"  },
        { text: "資格(役員役職)", align: "start", value: "officialPosition", width: "15%" },
        { text: "氏名", align: "start", value: "name", width: "24%" },
        // { text: "氏名(フリガナ)", align: "start", value: "nameKana", width: "24%" },
        { text: "登記の事由", align: "start", value: "changeOfficerClassName", width: "15%" },
        // { text: "役員変更詳細", align: "center", value: "data-table-expand", width: "15%" },
        { text: "役員住所", align: "center", value: "data-table-expand", width: "15%" },

        // { text: "原因年月日", align: "center", value: "causeDate", width: "10%" },
      ],
      desserts: [],
    };
  },
  created() {
    this.initialize();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollWindow);
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {

   onResize () {
      // this.isMobile = window.innerWidth < 450
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        this.isMobile = true;
      }
    }, 
 
   /*
    * 初期表示
    */
    initialize: function() {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mbr500.area');
      this.requestNo = Utils.removeChar(this.$route.params.requestNo, '-');
      let loggedUserInfo = this.$store.getters["authcUser/getLoggedUserInfo"];
      this.customerId = loggedUserInfo['id'];
      /* データ表示 */
      this.dispSearchData(this.customerId, this.requestNo);
      this.dispFileDownloadLink = this.checkFiledownloadFlg();
    },
    checkFiledownloadFlg: function() {
      let ckeckRslt = false;
      let agent = navigator.userAgent.toLowerCase();
      if (agent.indexOf('chrome') !== -1){
        ckeckRslt = true;
      }
      if (agent.indexOf('edge') !== -1){
        ckeckRslt = true;
      }
      if (agent.indexOf('firefox') !== -1){
        ckeckRslt = true;
      }
      return ckeckRslt;
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setLoginInfoMixin();
      this.username = authInfo['username'];
      this.companyname = authInfo['companyname'];
    },

   /*
    * 「戻る」ボタン押下
    */
    back: function() {
      // 遷移元画面へ戻る
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "MBR100" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },
    
   /*
    * 「アップロード」ボタン押下
    */
    uploadFileInfo: async function(file) {
      // サービス呼び出し
      let apiurl = Constants.getUrlApiMBR500P01(this.requestNo, this.fileId);
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      // 入力データ
      const requestFileData = new FormData()
      requestFileData.append('fileData', file)
      let data = requestFileData;
      let responseDto = null;
      try {
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
        {
          headers: {"X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
        });
        responseDto = response.data;
        if (responseDto.statusCd != 200) {
          this.dlgMsgErr.msg = responseDto.message;
          this.dlgMsgErr.isOpen = true;
        } else {
         //ファイル情報表示
         this.dispSearchDataForFileInfo(responseDto);
        }
      } catch(error) {
        console.log(error);
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm111', ['登記情報ファイル']);
        this.dlgMsgErr.isOpen = true;
      }
    },
    clearFileInfo : function(event) {
      event.target.value = "";
    },
    handleClickAppendOuter() {
      this.$refs.vFileInput.$el.querySelector("input").click();
    },

    /**
     * 「削除」ボタン押下
     */
    deleteFileInfo(requestNo,fileId) {
      this.dlgMsgConfirmDel.requestNo = requestNo;
      this.dlgMsgConfirmDel.fileId = fileId;
      this.dlgMsgConfirmDel.isOpen = true;
    },  
  
    /*
    * 「削除」ボタン押下
    */
    suspend: async function(requestNo, fileId) {
      // サービス呼び出し
      let apiurl = Constants.getUrlApiMBR500P02(requestNo, fileId);
      let data = {};
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      let responseDto = null;
      try {
        // API呼出
        let response = await this.$axios.put(apiurl, data, 
        {
          headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},  
          responseType: "json",
        });
        responseDto = response.data;
        if (responseDto.statusCd != 200) {
          this.dlgMsgErr.msg = responseDto.message;
          this.dlgMsgErr.isOpen = true;
        } else {
         //ファイル情報表示
         this.dispPdfFileBlobUrl = null;
         this.fileId = null;
        }
      } catch(error) {
        console.log(error);
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm113', ['登記情報ファイル']);
        this.dlgMsgErr.isOpen = true;
      }
    },

   /*
    * 「キャンセル」ボタン押下
    */
    cancel: function() {
      // 確認メッセージ表示
      this.dlgMsgConfirmCancel.isOpen = true;
    },

   /*
    * 「キャンセル」ボタン押下
    */
    requestCancel: async function() {
      // サービス呼び出し
      let apiurl = Constants.URL_API_MBR500P03;
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      let responseDto = null;
      try {
        let data = JSON.stringify(this.cancelRequestData());
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
        {
          headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},  
          responseType: "json",
        });
        responseDto = response.data;
         // 完了メッセージ表示
        if (!this.showDialogMsgAfterAPICall(this.dlgMsgErr, responseDto)){
          // データ再表示
          this.dispSearchData(this.customerId, this.requestNo);
        }
      } catch(error) {
        console.log(error);
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['お申込みのキャンセル']);
        this.dlgMsgErr.isOpen = true;
      }
    },    

    /*
    * 申込済情報取得・表示
    */
    dispSearchData : async function(customerId, requestNo) {
      // サービス呼び出し
      let apiurl = Constants.getUrlApiMBR500G01(customerId, requestNo);
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        // 申込済情報表示
        this.dispSearchResultData(response.data);
        // ファイル情報取得・表示
        this.dispSearchDataForFileInfo(response.data);
      } catch(error) {
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['お申込み内容']);
          this.dlgMsgErr.isOpen = true;
          this.desserts.push({});
      }
      return;
    },
    /*
    * ファイル情報取得・表示
    */
    dispSearchDataForFileInfo : async function(apiResponseData) {
       if (apiResponseData == null) {
        return;
      }
      let responseDto = apiResponseData.data;
      // let fileId = responseDto.fileId; 
      this.fileId = responseDto.fileId;
      if (this.fileId == 'null') {
        return;
      }
      let apiurl = Constants.getUrlApiMBR500G02(this.fileId);
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "blob",
            });
        // 申込済情報表示
        if (response.data == null || response.data.size == 0) {
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['ファイル情報']);
          this.dlgMsgErr.isOpen = true;
          this.desserts.push({});
          return;
        }
        this.dispPdfFileBlobUrl = window.URL.createObjectURL(response.data);
        this.dispPdfFileBlobUrl =  this.dispPdfFileBlobUrl + "#toolbar=0&navpanes=0";
      } catch(error) {
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['ファイル情報']);
          this.dlgMsgErr.isOpen = true;
          this.desserts.push({});
      }
      return;
    },
    /*
    * 画面表示用データの生成(申込済情報)
    */
    dispSearchResultData: function(apiResponseData) {
      if (apiResponseData == null) {
        return;
      }
      let responseDto = apiResponseData.data;
      this.dispRequestNo = responseDto.displayRequestNo; 
      this.dispRequesuDate = responseDto.displayRequestDatetime;
      /* -- 申込プラン表示情報 -- */
      this.dispPlanNm = responseDto.displayBasePlanName + "<br/>" + responseDto.displayOptionPlanName;

      // const blobFileData = new Blob([responseDto.fileData]);
      // this.dispPdfFileBlobUrl = window.URL.createObjectURL(blobFileData);
      // ファイル情報取得・表示
      this.dispSearchDataForFileInfo(apiResponseData);
      // ファイル情報パネル高さ調整
      this.modFileViewrHeght();
      this.fileUploadFlg = responseDto.fileUpload;
      /** 役員変更日付 */
      this.getDispChangeOfficerDate(responseDto);
      /* -- 役員情報 -- */
      this.desserts = [];
      if (responseDto.changeOfficerList != null) {
        let changeOfficer;
        for (const value of responseDto.changeOfficerList) {
          changeOfficer = {};
          changeOfficer['changeNo'] = value.changeNo;
          changeOfficer['officialPosition'] = value.officialPosition;
          changeOfficer['name'] = value.name;
          changeOfficer['nameKana'] = value.nameKana;
          changeOfficer['changeOfficerClassName'] = value.changeOfficerClassName;
          changeOfficer['address'] = value.officerAddress;
          // changeOfficer['regmatter'] = Utils.nl2br(value.regmatter);
          this.desserts.push(changeOfficer);
        }
      }
      /* -- 登記変更詳細情報 -- */
      // 改行コード置換, pタグ付加
      // this.dispRegChgInfo = "<p>" + Utils.nl2br(responseDto.regmatterBase) + "</p>";
      this.updateDatetime = responseDto.detailUpdateDatetime;
      this.updateUserId = responseDto.detailUpdateUserId;

      this.cancelInactive = responseDto.cancelInactive;
      this.cancelMessage = responseDto.cancelMessage;
    },
    /*
    * 変更日付
    */
    getDispChangeOfficerDate: function(responseDto) {
      let appointDate = responseDto.displayAppointDate;
      let resignDate = responseDto.displayResignDate;
      let othersDate = responseDto.displayOthersDate;
      if (appointDate != "" && appointDate != null) {
        this.dispChangeOfficerDate = "株主総会・取締役会の開催日付: " + appointDate;
      }
      if (resignDate != "" && resignDate != null) {
        if (this.dispChangeOfficerDate != "") {
          this.dispChangeOfficerDate = this.dispChangeOfficerDate + "<br/>"
        }
        this.dispChangeOfficerDate = this.dispChangeOfficerDate  + "退任等の日付: " + resignDate;
      }
      if (othersDate != "" && othersDate != null) {
        this.dispChangeOfficerDate = "住所移転日付: " + othersDate;
      }
    },
   /*
    * 申込みキャンセル用リクエストデータ生成
    */
    cancelRequestData : function() {
      let reqData = {};
      reqData['customerId'] = this.customerId;
      reqData['requestNo'] = this.requestNo;
      reqData['updateDatetime'] = this.updateDatetime;
      reqData['updateUserId'] = this.updateUserId;
      return reqData;
    },
    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null ) {
        dialog.msg = this.$i18n.t('msg.err.cm110', ['お申込みのキャンセル']);
        dialog.isOpen = true;
        this.initializeErr = true;
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
        }else{
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
          
        }
        return hasError;
      } else {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
      }
    },  

    /*
    * ファイル表示パネル高さ調整
    */
    modFileViewrHeght: function() {
      const iframeFile = document.getElementById("iframeFile");
      iframeFile.style.height = iframeFile.contentWindow.document.body.scrollHeight + "px";
      iframeFile.style.height = "80vh";
    },
    scrollWindow() {
      const top = 200
      this.scroll = window.scrollY
      if (top <= this.scroll) {
        this.buttonActive = true
      } else {
        this.buttonActive = false
      }
    },
  },
};
</script>

<style scoped>
.panel-title {
  color:#000000;
  background-color: #E0E0E0;
  font-size: 1.2em;
  font-weight: lighter;
}
/* 吹き出し */
.balloon {
  position: relative;
  display: inline-block;
  margin: 1.5em 0 1.5em 15px;
  padding: 7px 10px;
  min-width: 60%;
  max-width: 90%;
  color: #555;
  font-size: 16px;
  background: #ffcd93;
  border-radius: 10px;
}

.balloon:before {
  content: "";
  position: absolute;
  top: 25%;
  left: -15px;
  margin-top: -10px;
  border: 5px solid transparent;
  border-right: 10px solid #ffcd93;
}

@media screen and (max-width: 750px) {

}
</style>
